<template>
  <b-container active @click="tabClick(2017)" :id="`water-${year}`">
    <template slot="title">
      {{ "2019".toLowerCase().replace("_", " ") }}
    </template>
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">
      <b-row>
        <b-col cols="9">
          Water Data
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button size="sm" @click="requestDownload()">
            Export Water Data
          </b-button>
        </b-col>
      </b-row>
    </div>
    <ag-grid-vue style="width: 100%; height: 400px"
                 class="ag-theme-balham"
                 :gridOptions="topGridOptions"
                 :columnDefs="columnDefs"
                 :rowData="rowData"
                 :defaultColDef="defaultColDef"
                 :enterMovesDownAfterEdit="true"
                 @grid-ready="onGridReady"
                 @cell-clicked="onCellClicked"
                 @cell-editing-stopped="onCellEditingStopped">
    </ag-grid-vue>
    <ag-grid-vue style="width: 100%; height: 40px;"
                 class="ag-theme-balham"
                 :gridOptions="bottomGridOptions"
                 :headerHeight="0"
                 :columnDefs="bottomColumnDefs"
                 :rowData="bottomDataCalc"
                 :rowStyle="rowStyle"
    ></ag-grid-vue>

  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import Bus from "../eventBus";
import NumericEditor from "../numericEditor.js";
import {roundColumnValue} from "@/MetricUtils";
import {FileUtils} from "@/lib/FileUtils";


var SizeEnum = {
  WP: 'wineryProcess',
  TO: 'tastingOffices',
  LS: 'landscaping',
  WW: 'wastewater'
};

window.numberParser = function numberParser(params) {
  let parsedNumber = Number(params.newValue);
  return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
};

export default {
  name: "WaterMetricTable",
  props: {rows: Array, year: String, id: String, groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      metricYearVal: this.year,
      gridApi: null,
      gridColumnApi: null,
      bottomColumnDefs: null,
      columnDefs: null,
      defaultColDef: null,
      pinnedTopRowData: null,
      pinnedBottomRowData: null,
      topGridOptions: null,
      bottomGridOptions: null,
      rowData: this.rows,
      bottomData: [],
      rowStyle: {fontWeight: 'bold'},
      metricId: this.id,
      myGroupId: this.groupId,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  watch: {
    rows: function (newVal) {
      this.rowData = newVal;
      this.$nextTick(() => {
        console.log("Metric Year Value", this.metricYearVal);
        this.sendMetricsUpdate(this.metricYearVal);
      });
    }
  },
  mounted() {
    console.log("WaterMetric Mountedx")
    this.gridApi = this.topGridOptions.api;
    this.gridColumnApi = this.topGridOptions.columnApi;
    this.gridApi.setRowData(this.rowData);
    //this.bottomData = this.bottomDataCalc()
    this.$nextTick(this.sendMetricsUpdate(this.metricYearVal));
  },
  beforeMount() {

    this.columnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Gallons Winery Process, Tasting Offices',
        field: 'wineryProcess',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Gallons Other', field: 'tastingOffices',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Gallons Landscaping',
        field: 'landscaping',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Wastewater',
        field: 'wastewater',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      }
    ];

    this.bottomColumnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Gallons Winery Process, Tasting Offices',
        field: 'wineryProcess',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Gallons Other', field: 'tastingOffices',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Gallons Landscaping',
        field: 'landscaping',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Wastewater',
        field: 'wastewater',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      }
    ];
    console.log(`Water Metric Is Viewer: ${this.isViewer}`)
    this.bottomData = [
      {
        month: 'Total',
        year: '******',
        wineryProcess: 'a lot',
        tastingOffices: 'not as much',
        landscaping: 'a little more',
        wastewater: '0'
      }
    ];

    this.defaultColDef = {
      editable: true,
      resizable: true
    };
    this.pinnedTopRowData = getPinnedTopData();
    this.pinnedBottomRowData = getPinnedBottomData();

    this.topGridOptions = {alignedGrids: [], suppressHorizontalScroll: true};
    this.bottomGridOptions = {
      alignedGrids: [],
      enableCellExpressions: true,
      context: {
        theNumber: 4
      }
    };

    this.frameworkComponents = {
      numericEditor: NumericEditor
    };
    this.topGridOptions.alignedGrids.push(this.bottomGridOptions);
    this.bottomGridOptions.alignedGrids.push(this.topGridOptions);

  },
  computed: {
    bottomDataCalc: function () {

      let self = this;
      let columnNames = [];
      Object.values(SizeEnum).map(key => {
        let result = 0;
        Object.values(self.rowData).forEach(row => {
          result += row[key];
        });
        columnNames.push(result);
      });

      let bottom =
          {
            month: 'Total',
            year: '******',
            wineryProcess: 0,
            tastingOffices: 0,
            landscaping: 0
          };
      if (columnNames.length > 0) {
        bottom = {
          month: "Total",
          year: '******',
          wineryProcess: columnNames[0],
          tastingOffices: columnNames[1],
          landscaping: columnNames[2],
          wastewater: columnNames[3]
        };
      }

      console.log(bottom);

      return [bottom];
    }

  },
  methods: {
    bottomDataCalcFunc: function (year) {

      let self = this;
      let bottomRowsMap = new Map();
      let columnNames = [];
      Object.values(self.rowData).forEach(row => {
        Object.values(SizeEnum).map(key => {
          let result = 0;
          row.forEach(function (item) {
            result += item[key];
          });
          columnNames.push(result);
        });
        //bottomRowsMap.set(year, columnNames)
      });

      let bottom =
          {
            month: "Total",
            year: '******',
            solarProductivity: 0,
            electricMeter: 0,
            electricMeter2: 0,
            electricMeter3: 0
          };

      console.log(bottom);

      return [bottom];
    },
    tabClick: function () {
    },
    onBtStopEditing() {
      this.gridApi.stopEditing();

    },
    cellValueChanged() {
      this.bottomGridOptions.api.refreshView();
    },
    onBtStartEditing(key, char, pinned) {
      this.gridApi.setFocusedCell(0, "month", pinned);
      this.gridApi.startEditingCell({
        rowIndex: 0,
        colKey: "month",
        rowPinned: pinned,
        keyPress: key,
        charPress: char
      });
    },
    onBtNextCell() {
      this.gridApi.tabToNextCell();
    },
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/${self.metricYearVal}/water/wine`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
    onBtWhich() {
      let cellDefs = this.gridApi.getEditingCells();
      if (cellDefs.length > 0) {
        var cellDef = cellDefs[0];
        console.log(
            "editing cell is: row = " +
            cellDef.rowIndex +
            ", col = " +
            cellDef.column.getId() +
            ", floating = " +
            cellDef.floating
        );
      } else {
        console.log("no cells are editing");
      }
    },
    onGridReady(params) {

      this.gridApi = this.topGridOptions.api;
      this.gridColumnApi = this.topGridOptions.columnApi;
      const updateData = data => {
        this.rowData = data;
      };
    },
    onCellClicked(event) {
      //console.log('onCellClicked: ' + event.rowIndex + ' ' + event.colDef.field);

    },
    sendMetricsUpdate: function (year) {
      let totalWineryProcess = 0;
      let totalTastingOffices = 0;
      let totalLandscaping = 0;
      if (this.gridApi !== undefined) {
        this.gridApi.forEachNode(function (node) {
          if (node.data["year"] === year || node.data["year"] === year.toString()) {
            totalWineryProcess += Number(node.data["wineryProcess"]) || 0;
            totalTastingOffices += Number(node.data["tastingOffices"]) || 0;
            totalLandscaping += Number(node.data["landscaping"]) || 0;
          }
        });
      }
      this.calculateAndEmitWaterTotals(totalWineryProcess, totalTastingOffices, totalLandscaping, event);
    },
    calculateAndEmitWaterTotals: function (totalWineryProcess, totalTastingOffices, totalLandscaping, event) {
      this.bottomGridOptions.api.getRowNode('0').data["wineryProcess"] = totalWineryProcess;
      this.bottomGridOptions.api.getRowNode('0').data["tastingOffices"] = totalTastingOffices;
      this.bottomGridOptions.api.getRowNode('0').data["landscaping"] = totalLandscaping;

      let theGridType = "waterGrid";
      let emitTotal = totalWineryProcess;

      let waterEmission = {
        gridType: theGridType, wineryProcess: totalWineryProcess,
        tastingOffices: totalTastingOffices, landscaping: totalLandscaping,
        year: this.metricYearVal
      };
      Bus.$emit('grid-edited', waterEmission);
    },
    calculateAndUpdateTotalsVuex: function (totalWineryProcess, totalTastingOffices, totalLandscaping, event) {
      this.bottomGridOptions.api.getRowNode('0').data["wineryProcess"] = totalWineryProcess;
      this.bottomGridOptions.api.getRowNode('0').data["tastingOffices"] = totalTastingOffices;
      this.bottomGridOptions.api.getRowNode('0').data["landscaping"] = totalLandscaping;

      let theGridType = "waterGrid";
      let emitTotal = totalWineryProcess;

      let waterEmission = {
        gridType: theGridType,
        wineryProcess: totalWineryProcess,
        tastingOffices: totalTastingOffices,
        landscaping: totalLandscaping,
        year: this.metricYearVal
      };
      this.$store.commit('wineryMetrics/wineryProcess', totalWineryProcess);
      this.$store.commit('wineryMetrics/tastingOffices', totalTastingOffices);
      this.$store.commit('wineryMetrics/landscaping', totalLandscaping);
      console.log("Updated Vineyard Water Totals to Vuex");
      Bus.$emit('grid-edited', waterEmission);
      console.log("Updated Vineyard Water Totals to Bus");
    },
    safeParseNumber: function (node, indexName) {
      let isNotANumber = isNaN(node.data[indexName]);
      //console.log(`Is Not a Number: ${isNotANumber}, Node Value: ${node.data[indexName]} returned Value: ${isNotANumber ? 0 : node.data[indexName]}`);
      return isNotANumber ? 0 : node.data[indexName];
    },
    onCellEditingStopped(event) {
      console.log('onCellEditingStopped: ' + event.rowIndex + ' ' + event.colId);
      let self = this;
      console.log(event)
      console.log(event.cellIndex)
      console.log(event.colDef.field)

      //let items: Array<rows> = [];
      let total = 0;
      let totalWineryProcess = 0;
      let totalTastingOffices = 0;
      let totalLandscaping = 0;
      let totalWastewater = 0;
      if (self.gridApi !== undefined) {
        self.gridApi.forEachNode(function (node) {
          if (node.data["year"] === event.data["year"]) {
            totalWineryProcess += self.safeParseNumber(node, "wineryProcess");
            totalTastingOffices += self.safeParseNumber(node, "tastingOffices");
            totalLandscaping += self.safeParseNumber(node, "landscaping");
            totalWastewater += self.safeParseNumber(node, "wastewater");
          }
        });
      }

      if (self.gridApi !== undefined) {
        let numberOfRows = 0;
        let allPowerMetrics = [];
        let year = {};
        let waterMetricsMonth = [];
        self.gridApi.forEachNode(function (node) {
          year = node.data["year"];
          waterMetricsMonth.push({
            month: node.data["month"],
            wineryProcess: self.safeParseNumber(node, "wineryProcess"),
            tastingOffices: self.safeParseNumber(node, "tastingOffices"),
            landscaping: self.safeParseNumber(node, "landscaping"),
            wastewater: self.safeParseNumber(node, "wastewater"),
          })
        });
        let metricYear = {
          _id: this.id,
          year: year,
          groupId: this.myGroupId,
          months: waterMetricsMonth
        }
        console.log("Metrics Year");
        console.log(JSON.stringify(metricYear));
        this.$http.put("/metrics/water/" + this.metricId, JSON.stringify(metricYear), {
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => {
          console.log(response);
          if (self.id === null) {
            self.id = response.data;
            self.metricId = self.id;
          }
        }).catch(error => {
          console.log("Error Putting Data");
          console.error(error);
        })
      }
      this.calculateAndUpdateTotalsVuex(totalWineryProcess, totalTastingOffices, totalLandscaping, event);
      this.bottomGridOptions.api.redrawRows({rowNodes: [this.bottomGridOptions.api.getRowNode('0')]})
    },
    onBtPreviousCell() {
      this.gridApi.tabToPreviousCell();
    },
  }
}

function getPinnedTopData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getPinnedBottomData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getCharCodeFromEvent(event) {
  event = event || window.event;
  return typeof event.which === "undefined" ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
  return !!/\d/.test(charStr);
}

function isKeyPressedNumeric(event) {
  var charCode = getCharCodeFromEvent(event);
  var charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}
</script>

<style scoped>

</style>
